import { DateTime } from 'luxon';

export function formatNumberWithCommas(num?: number): string {
  if (num === undefined || num === null) {
    return '';
  }
  return num.toLocaleString('en-US');
}

export function formatNumberWithShortSymbol(num?: number): string {
  if (!num) {
    return '0';
  }

  switch (true) {
    case num >= 1_000_000:
      return (num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 1) + 'M';
    case num >= 1_000:
      return (num / 1_000).toFixed(num % 1_000 === 0 ? 0 : 1) + 'K';
    default:
      return num.toString();
  }
}

export function formatDateToFormatWithWeeks(date?: string | null): string {
  if (!date) {
    return '';
  }

  const dt = DateTime.fromISO(date, { zone: 'CET' });

  const formatted = dt.toFormat("cccc HH:mm 'CET'");

  return formatted;
}
